import { AnyAction } from 'redux';
import { CLEAR_NOMINEE_POPUP, LOGOUT_SUCCESS, SHOW_NOMINEE_POPUP } from '../types/auth';

export type NomineePopupState = {
  open: boolean;
  statusCode: number | null;
};

const initialState: NomineePopupState = {
  open: false,
  statusCode: null,
};

export default function nomineePopupReducer(
  state: NomineePopupState = initialState,
  action: AnyAction
): NomineePopupState {
  switch (action.type) {
    case SHOW_NOMINEE_POPUP:
      return { open: true, statusCode: action.statusCode ?? null };
    case CLEAR_NOMINEE_POPUP:
    case LOGOUT_SUCCESS:
      return { ...initialState };
    default:
      return state;
  }
}
